const React = require('react');
const ReactDOM = require('react-dom');
require('./module.scss');

const ImageGallery = React.createClass({
  propTypes: {
    images: React.PropTypes.array.isRequired,
    isOpen: React.PropTypes.bool,
    initialIndex: React.PropTypes.number,
    onClose: React.PropTypes.func,
    closeOnClickOutside: React.PropTypes.bool
  },

  getDefaultProps: function () {
    return {
      initialIndex: 0,
      isOpen: false,
      closeOnClickOutside: true
    };
  },

  getInitialState: function () {
    return {
      currentIndex: this.props.initialIndex,
      zoom: 1,
      position: { x: 0, y: 0 },
      isDragging: false,
      dragStart: { x: 0, y: 0 },
      containerSize: { width: 0, height: 0 },
      naturalSize: { width: 0, height: 0 },
      fitZoom: 1,
      isLoading: true,
      loadError: false
    };
  },

  componentDidMount: function () {
    this.updateContainerSize();
    window.addEventListener('resize', this.updateContainerSize);
    document.addEventListener('keydown', this.handleKeyDown);
  },

  componentDidUpdate: function (prevProps) {
    const node = ReactDOM.findDOMNode(this);
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({
        currentIndex: this.props.initialIndex || 0,
        isLoading: true,
        loadError: false
      });
      node.addEventListener('wheel', this.handleWheel);
      this.updateContainerSize();
      this.setState({ isLoading: true, loadError: false });
    } else if (node && !this.props.isOpen && prevProps.isOpen) {
      node.removeEventListener('wheel', this.handleWheel);
    }
  },

  componentWillUnmount: function () {
    window.removeEventListener('resize', this.updateContainerSize);
    document.removeEventListener('keydown', this.handleKeyDown);
    const node = ReactDOM.findDOMNode(this);
    if (node) node.removeEventListener('wheel', this.handleWheel);
  },

  updateContainerSize: function () {
    this.setState({
      containerSize: {
        width: window.innerWidth * 0.8,
        height: window.innerHeight * 0.8
      }
    });
  },

  handleKeyDown: function (e) {
    if (!this.props.isOpen) return;
    if (e.keyCode === 27) this.handleClose(); // ESC
    if (e.keyCode === 37) this.goToPrev(); // ←
    if (e.keyCode === 39) this.goToNext(); // →
  },

  handleClose: function () {
    this.setState({
      currentIndex: this.props.initialIndex || 0,
      zoom: 1,
      position: { x: 0, y: 0 },
      isLoading: true,
      loadError: false
    });
    if (this.props.onClose) this.props.onClose();
  },

  handleWheel: function (e) {
    e.preventDefault();
    const zoomStep = e.deltaY < 0 ? 0.1 : -0.1;
    const newZoom = Math.max(0.1, this.state.zoom + zoomStep);

    const finalZoom = this.isPortrait()
      ? Math.max(newZoom, this.state.fitZoom)
      : newZoom;

    this.setState({
      zoom: finalZoom,
      position: { x: 0, y: 0 }
    });
  },

  handleMouseDown: function (e) {
    this.setState({
      isDragging: true,
      dragStart: {
        x: e.clientX - this.state.position.x,
        y: e.clientY - this.state.position.y
      }
    });
    e.preventDefault();
  },

  handleMouseMove: function (e) {
    if (!this.state.isDragging) return;
    this.setState({
      position: {
        x: e.clientX - this.state.dragStart.x,
        y: e.clientY - this.state.dragStart.y
      }
    });
  },

  handleMouseUp: function () {
    this.setState({ isDragging: false });
  },

  handleImageLoad: function (e) {
    const img = e.target;
    const { width, height } = this.state.containerSize;
    const naturalRatio = img.naturalWidth / img.naturalHeight;
    const containerRatio = width / height;

    const fitZoom = naturalRatio > containerRatio
      ? width / img.naturalWidth
      : height / img.naturalHeight;

    this.setState({
      naturalSize: {
        width: img.naturalWidth,
        height: img.naturalHeight
      },
      fitZoom: fitZoom,
      zoom: fitZoom,
      isLoading: false,
      loadError: false
    });
  },

  handleImageError: function () {
    this.setState({
      isLoading: false,
      loadError: true
    });
  },

  isPortrait: function () {
    return this.state.naturalSize.height > this.state.naturalSize.width;
  },

  goToPrev: function () {
    const newIndex = (this.state.currentIndex - 1 + this.props.images.length) % this.props.images.length;
    this.setState({
      currentIndex: newIndex,
      zoom: 1,
      position: { x: 0, y: 0 },
      isLoading: true,
      loadError: false
    });
  },

  goToNext: function () {
    const newIndex = (this.state.currentIndex + 1) % this.props.images.length;
    this.setState({
      currentIndex: newIndex,
      zoom: 1,
      position: { x: 0, y: 0 },
      isLoading: true,
      loadError: false
    });
  },

  renderImage: function () {
    const imageData = this.props.images[this.state.currentIndex];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData.src;
    const altText = typeof imageData === 'string' ? '' : (imageData.alt || '');

    return (
      <div className="image-container">
        {this.state.isLoading && (
          <div className="loading-indicator">
            <div className="loading-spinner"></div>
          </div>
        )}

        {this.state.loadError && (
          <div className="error-message">
            图片加载失败
          </div>
        )}

        <img
          src={imageSrc}
          alt={altText}
          style={{
            transform: `translate(${this.state.position.x}px, ${this.state.position.y}px) scale(${this.state.zoom})`,
            cursor: this.state.isDragging ? 'grabbing' : 'grab'
          }}
          className={this.state.isLoading ? 'hidden' : ''}
          onMouseDown={this.handleMouseDown}
          onLoad={this.handleImageLoad}
          onError={this.handleImageError}
        />
      </div>
    );
  },

  renderNavigation: function () {
    if (this.props.images.length <= 1) return null;

    return (
      <div>
        <button
          className="nav-button prev-button"
          onClick={(e) => {
            e.stopPropagation();
            this.goToPrev();
          }}
        >
          <i className='left'></i>
        </button>
        <button
          className="nav-button next-button"
          onClick={e => {
            e.stopPropagation();
            this.goToNext();
          }}
        >
          <i className='right'></i>
        </button>
      </div>
    );
  },

  render: function () {
    if (!this.props.isOpen) return null;

    const containerStyle = {
      width: this.state.containerSize.width + 'px',
      height: this.state.containerSize.height + 'px'
    };

    return (
      <div className="image-gallery">
        <div
          className="gallery-overlay"
          onClick={this.props.closeOnClickOutside ? this.handleClose : null}
        >
          {this.renderNavigation()}
          <div
            className="gallery-content"
            style={containerStyle}
            onClick={function (e) { e.stopPropagation(); }}
            onMouseMove={this.handleMouseMove}
            onMouseUp={this.handleMouseUp}
            onMouseLeave={this.handleMouseUp}
          >
            {this.renderImage()}
          </div>
          <div className="image-counter">
            {this.state.currentIndex + 1} / {this.props.images.length}
          </div>
        </div>
      </div>
    );
  }
});

module.exports = ImageGallery;



// WEBPACK FOOTER //
// ./component/imgDialog/index.js